import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelPortfolioInitContributionInterface } from '../interfaces/model-portfolio-initcontribution.interface';

@JsonObject('ModelPortfolioInitContribution')
export class ModelPortfolioInitContribution
  implements ModelPortfolioInitContributionInterface
{
  AnalysisDate?: string;
  AssetClassDistribution?: AssetClassDistribution[];
  AssetTypeDistribution?: AssetTypeDistribution[];
  BaseCurrency?: string;
  BuyListCompositions?: any[];
  Center?: Center;
  Comment?: string;
  CountryDistribution?: any[];
  CurrencyDistribution?: CurrencyDistribution[];
  DefaultRate?: DefaultRate;
  Description?: string;
  ExternalCode?: string;
  MinimumContribution?: number;
  MinimumInvest?: number;
  MinimumWithdrawal?: number;
  ModelPortfolioCode?: string;
  ModelPortfolioCodeView?: string;
  Name?: string;
  Performance1Y?: number;
  Performance1YOpen?: number;
  Performance6M?: number;
  PerformanceYTD?: number;
  PivotFund?: PivotFund;
  Products?: Product[];
  Profile?: Profile;
  RankingCompositions?: any[];
  RatioSharpe?: number;
  RegionDistribution?: any[];
  SectorDistribution?: any[];
  serviceType?: ServiceType;
  TopPositionsFunds?: any[];
  Type?: string;
  VaR95?: number;
  VisualGroupName?: string;
  Volatility?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AssetClassDistribution')
export class AssetClassDistribution {
  BankCode?: any;
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AssetTypeDistribution')
export class AssetTypeDistribution {
  BankCode?: any;
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Center')
export class Center {
  CenterCode?: string;
  CenterName?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('CurrencyDistribution')
export class CurrencyDistribution {
  BankCode?: any;
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('DefaultRate')
export class DefaultRate {
  RateCode?: string;
  RateName?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('PivotFund')
export class PivotFund {
  ProductCode?: string;
  ProductCodeView?: string;
  ProductISIN?: string;
  ProductName?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Product')
export class Product {
  Currency?: string;
  ProductCode?: string;
  ProductIdentifier?: string;
  ProductISIN?: string;
  ProductName?: string;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('ProfileInit')
export class Profile {
  ProfileCode?: string;
  ProfileName?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('ServiceType')
export class ServiceType {
  ServiceTypeCode?: string;
  ServiceTypeName?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
